<template>
  <modal name="contract-request-modal"
         @closed="$emit('updateComparisonData')"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Պայմանագրի կնքում</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('contract-request-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <template v-if="participantGroups.length === 0">
        <div class="text-center">
          Բոլոր հնարավոր պայմանագրերը կնքված են
        </div>
      </template>
      <table v-else class="table table-bordered">
        <thead>
          <tr>
            <th style="width: 120px;">Հ/Հ</th>
            <th>Մասնակցի անվանում</th>
            <th>Մասնակցի հեռախոսահամար</th>
            <th>Մասնակցի Էլ. հասցե</th>
            <!-- <th>Պայմանագրի պատասխան</th> -->
            <th>Կնքում</th>
          </tr>
        </thead>
        <tbody id="negotiation-table" style="min-height: 5vh; max-height: 40vh!important; overflow: scroll">
          <template v-for="(participantGroup, participantIndex) in participantGroups">
              <tr v-if="!getIsSigned(participantGroup)" :key="participantIndex">
                <td>{{ participantIndex+1 }}</td>
                <td>{{ participantGroup.participant[0].name.hy }}</td>
                <td>{{ participantGroup.participant[0].phone }}</td>
                <td>{{ participantGroup.participant[0].email }}</td>
                <!-- <td>
                  <select v-model="participantGroup.contractResponse" class="form-control">
                    <option :value="true">Ստացվել է</option>
                    <option :value="false">Չի ստացվել</option>
                  </select>
                </td> -->
                <td>
                  <div class="row" v-if="participantGroup.director">
                    <div class="col-6">
                      <button
                        @click.prevent="() => {
                          $modal.show('contract-sign-modal', {participantGroup, confirmContract, participantIndex})
                        }"
                        :disabled="!participantGroup.signed_contract_hy"
                        type="button" 
                        class="btn btn-sm btn-success">
                          Կնքել
                      </button>
                      <div class="mt-2 text-danger">Բեռնեք տվյալ մասնակցի հետ Պայմանագիր փաստաթուղթը, որը հետագայում կօգտագործվի պայմանգրի կառավարում բաժնում'</div>
                    </div>
                    <div class="col-6">
                      <button
                        @click="cancelContract(participantGroup)"
                        type="button" 
                        class="btn btn-sm btn-danger">
                          Չեղարկել
                      </button>
                    </div>
                  </div>
                  <div v-else>
                    Լրացրեք մասնակցի վավերապայմաները
                  </div>
                </td>
              </tr>
            </template>
        </tbody>
      </table>
      <infinite-loading slot="append"
                        class="w-100"
                        ref="negotiationInfiniteLoading"
                        @infinite="infiniteHandler"
                        force-use-infinite-wrapper="#negotiation-table">
        <div slot="no-results"></div>
        <div slot="no-more"></div>
      </infinite-loading>
    </div>
    <contract-sign-modal />
  </modal>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading';
  import ContractSignModal from './ContractSignModal'

  export default {
    name: 'NegotiationsModal',
    components: { InfiniteLoading, ContractSignModal },
    data() {
      return {
        participantGroups: [],
        pagination: {},
      }
    },
    computed: {
      currentOrganized() {
        return this.$store.getters['organize/currentOrganized']
      },
      locale() {
        return this.$store.getters['user/locale']
      }
    },
    methods: {
      getIsSigned(participantGroup){
        var isSigned = true;
        participantGroup.won_lots.forEach((lot) => {
          const offer = participantGroup.lots.find(item => item.organize_row_id === lot.id)
          if(!offer.get_response){
            isSigned = false;
          }
        })
        return isSigned
      },
      confirmContract(participantGroup) {
        participantGroup.won_lots.forEach((lot) => {
          const offer = participantGroup.lots.find(item => item.organize_row_id === lot.id)
          this.$client.put(`participant-row/${offer.id}`, {get_response: true})
        })
        const optionIndex = this.participantGroups.findIndex(item => item.id === participantGroup.id)
        this.participantGroups.splice(optionIndex, 1)
      },
      cancelContract(participantGroup) {
         participantGroup.won_lots.forEach((lot) => {
          const offer = participantGroup.lots.find(item => item.organize_row_id === lot.id)
          this.$client.put(`participant-row/${offer.id}`, {canceled_contract_request: true})
          this.$client.get(`participant-row/getWinnerByOrganizeRowId/${offer.organize_row_id}`).then(response => {
            const results = response.data;
            const newWinner = results[0];
            if(newWinner !== undefined){
              $client.put(`organize-row/${lot.id}`, {winner_participant_id: newWinner.participant_group_id}).then(response => {
                console.log(response)
              })
            } else {
              $client.put(`organize-row/${lot.id}`, {winner_participant_id: 0}).then(response => {
                console.log(response)
              })
            }
          })
        })
        const optionIndex = this.participantGroups.findIndex(item => item.id === participantGroup.id)
        this.participantGroups.splice(optionIndex, 1)
      },
      async infiniteHandler($state) {
        this.participantGroups = [];
        await this.$client.get(`participant-group/getByOrganize/getWonLots/${this.$route.params.id}`).then(response => {
          const results = response.data;
          if(results) {
            results.forEach(participant => {
              if(participant.won_lots.length>0){
                participant.contractResponse = false;
                console.log(participant)
                if(!this.getIsSigned(participant)){
                  this.participantGroups.push(participant)
                }
              }
            });
            $state.complete()
          } else{
            $state.complete()
          }
        }).catch(e => {
          $state.complete()
        })
      },
      consoleLog(msg) {
        console.log(msg)
      },
      getNewOverall(participant) {
        let overall = null
        if(participant.new_price) {
          overall = participant.new_price
          if(participant.vat) {
            overall += participant.new_price*0.2
          }
        }
        if(overall) {
          return Number(overall.toFixed(2))
        }

        return overall
      },
    }
  }
</script>

<style scoped>

</style>
